<template>
    <div>

        <section class="feature-section">
            <div class="container">
                <div class="row ">

                  <div class="col-12 text-left">
                    <h2>End User License Agreement</h2>
                    <p>By using Skippr, you agree to the <a href="https://skippr.io/eula.pdf">End User License Agreement</a>.</p>
                    <a href="https://skippr.io/eula.pdf" class="btn btn-primary">Download EULA</a>
                  </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    export default {
        name: 'PaulHudson',
        props: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>

